var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{ref:"container",staticClass:"d3-chart"},[_c('div',{ref:"tooltip",staticClass:"d3-chart-tooltip",attrs:{"role":"tooltip"}})])}
var staticRenderFns = []

export { render, staticRenderFns }